import { render, staticRenderFns } from "./left-navbar.vue?vue&type=template&id=1046fcf9&"
import script from "./left-navbar.vue?vue&type=script&lang=ts&"
export * from "./left-navbar.vue?vue&type=script&lang=ts&"
import style0 from "./left-navbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports